module.exports = __webpack_public_path__ + "afae2a3a500f6309aaf489c59883984a.svg";